import styled from 'styled-components';

import { ButtonStyled } from '../../../../components/Button/Button.styled';
import { SectionWrapperStyled } from '../../PaymentDetailsPage.styled';

type FlexDirectionT =
  | 'column'
  | 'inherit'
  | '-moz-initial'
  | 'initial'
  | 'revert'
  | 'unset'
  | 'column-reverse'
  | 'row'
  | 'row-reverse'
  | undefined;

export const FIELD_STYLES = {
  base: {
    fontSize: '14px',
  },
  invalid: {
    color: '#ff0000',
  },
};

export const CONFIRM_POPUP_STYLE = {
  minHeight: '300px',
  display: 'flex',
  flexDirection: 'column' as FlexDirectionT,
  justifyContent: 'center',
};

export const PaymentFormWrapperStyled = styled(SectionWrapperStyled)`
  .StripeElement {
    height: 40px;
    padding: 11px;
    border: 1px solid #d0d0d0;
    border-radius: 4px;

    &.StripeElement--focus {
      border-color: ${({ theme }) => theme.primaryColour};
    }

    &.StripeElement--invalid {
      border-color: #ff0000;
    }
  }
`;

export const CardsWrapperStyled = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;

  img {
    height: 30px;
  }
`;

export const ServerErrorStyled = styled.div`
  color: #ff0000;
  border: 1px solid #ff0000;
  border-radius: 4px;
  padding: 10px;
  margin-top: 25px;

  ${({ theme }) => `
    font-weight: ${theme.fontWeights.medium};
  `}
`;

export const PopupControlsWrapperStyled = styled.div`
  display: flex;
  justify-content: center;
  gap: 30px;
  flex-wrap: wrap;
  margin-top: 30px;

  ${ButtonStyled} {
    max-width: 250px;
    width: 100%;
  }
`;

export const ConfirmPopupContentStyled = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: center;
`;
